import { getRequest } from '../services/requestHandler';
import { PutterHeadModelForSaveDto } from '../models';

export const getPutterHeadModels = async () => {
  const url = 'putter/getPutterHeadModels?useCache=true';
  const response = await getRequest<PutterHeadModelForSaveDto>('GetPutterHeadModels', url);
  return response;
};
